import React from "react";

import Body from "./Body";

const Promotion = {
  title: "Earn yield",
  body: <Body />,
};

export default Promotion;
